// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
//require("jquery-autocomplete")
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";

Rails.start()
Turbolinks.start()
ActiveStorage.start()
global.Turbolinks = Turbolinks;

document.addEventListener('turbolinks:click', function (event) {
  var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
  if (!link) {
    return;
  }

  var href = link.getAttribute('href') || '';
  if (href.charAt(0) === '#' || link.target === '_blank' || link.hasAttribute('download')) {
    return;
  }

  var url;
  try {
    url = new URL(href, window.location.href);
  } catch (error) {
    return;
  }

  if (url.origin !== window.location.origin) {
    return;
  }

  if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
    return;
  }

  if (link.dataset.scrollTop === 'false') {
    return;
  }

  window.__kairosScrollTopAfterVisit = true;
});

document.addEventListener('turbolinks:load', function () {
  if (!window.__kairosScrollTopAfterVisit) {
    return;
  }

  window.__kairosScrollTopAfterVisit = false;
  window.requestAnimationFrame(function () {
    window.scrollTo(0, 0);
  });
});

require("channels")
require ("jquery-ui/ui/widgets/autocomplete")



 
 

// jquery
import $ from 'jquery';
global.$ = $;
global.jQuery = $;
import 'stylesheets/application'
require("./custom/places")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
